export default {
    /** 跳转页面 */
    toRoute(router, path, query = {}, time = 0) {
        setTimeout(() => {
            router.push({
                path,
                query
            });
        }, time);
    },

    /** 打开新页面 */
    openNewPage(path, query = {}) {
        const queryString = Object.entries(query)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

        const fullPath = queryString ? `${path}?${queryString}` : path;
        window.open(fullPath, '_blank');
    },
    /** 返回上一页*/
    goBack(time  = 0) {
        setTimeout(()=>{
            window.history.back();
        },time)
    }
}
